// extracted by mini-css-extract-plugin
module.exports = {"content":"_bb","title":"_bc","container":"_bd","wrapper":"_be","sidebar":"_bf","banner":"_bg","banner__last_page":"_bh"};